export default __webpack_public_path__ + "static/media/pushyy_logo_n.b4f38e94.jpg";